import KeyFigure from './DtoKeyFiguresRow'

export default class {
	constructor(obj) {
		this.id = obj.id
		this.code = obj.code
        this.keyFigure = obj.keyFigure ? new KeyFigure(obj.keyFigure) : undefined
        this.typeId = obj.typeId
        this.typeParameter = obj.typeParameter
        this.name = obj.name
        this.xCoordinate = obj.xCoordinate
        this.yCoordinate = obj.yCoordinate
        this.keyFigures = obj.keyFigures ? obj.keyFigures.map(o => new KeyFigure(o)) : []
	}
}



// WEBPACK FOOTER //
// ./src/sites/dto/DtoStationRow.js